 export const checkValidity = (value, rules) => {
    let isValid = true;
    if(!rules){
        return true
    }
    if(rules.required){
        isValid = value.trim() !== '' && isValid;
    }
    if(rules.minLength){
        isValid = value.length >= rules.minLength && isValid;
    }
    if(rules.maxLength){
        isValid = value.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(value) && isValid
    }

    if (rules.isNumeric) {
        const pattern = /^\d+$/;
        isValid = pattern.test(value) && isValid
    }        
    return isValid
}

export const capitalizeAndParse =(string) => {
    if(!string) return "";
    let something = string.split('_').map(
        (text) => { 
           return text ? text.charAt(0).toUpperCase() + text.slice(1) : " "
        }).join(' ')
        return something;
}

export const capitalizeAndParseCamel =(string) => {
    if(!string) return "";
    string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
    string = string.charAt(0).toUpperCase() + string.slice(1, string.length-3);
    return string;
}
